import Icon from '../../../components/AppIcon';

const ContactInformation = ({ photographer }) => {
  const phone = photographer?.phone;
  if (!phone) return null;

  const waLink = `https://wa.me/${phone?.replace(/\D/g, '')}`;
  const callLink = `tel:${phone}`;

  return (
    <div className="bg-white rounded-2xl shadow-sm border border-slate-100 p-5">
      <h3 className="text-sm font-bold text-slate-700 mb-3 flex items-center gap-2">
        <Icon name="Phone" size={15} className="text-primary" />
        التواصل مع المصور
      </h3>
      <div className="flex gap-2">
        <a
          href={callLink}
          className="flex-1 flex items-center justify-center gap-2 py-2.5 rounded-xl bg-primary text-white text-sm font-semibold"
        >
          <Icon name="Phone" size={15} />
          <span>اتصال</span>
        </a>
        <a
          href={waLink}
          target="_blank"
          rel="noopener noreferrer"
          className="flex-1 flex items-center justify-center gap-2 py-2.5 rounded-xl bg-green-500 text-white text-sm font-semibold"
        >
          <Icon name="MessageCircle" size={15} />
          <span>واتساب</span>
        </a>
      </div>
      <p className="text-center text-xs text-slate-400 mt-2">{phone}</p>
    </div>
  );
};

export default ContactInformation;
